import type { ApiResponse } from '@/shared/types';
import api from '@/shared/api/client';

export type OutboxStatus = 'PENDING' | 'PROCESSING' | 'COMPLETED' | 'DEAD';
export type OutboxChannel =
  | 'audit'
  | 'webhook'
  | 'email'
  | 'notification'
  | 'ai_call_log'
  | 'report_log'
  | 'batch_event';

export const OUTBOX_STATUSES: OutboxStatus[] = [
  'PENDING',
  'PROCESSING',
  'COMPLETED',
  'DEAD',
];

export const OUTBOX_CHANNELS: OutboxChannel[] = [
  'audit',
  'webhook',
  'email',
  'notification',
  'ai_call_log',
  'report_log',
  'batch_event',
];

export const operatorOutboxApi = {
  listOutboxMessages: (params?: {
    status?: OutboxStatus;
    channel?: OutboxChannel;
    tenantId?: string;
    page?: number;
    pageSize?: number;
  }) =>
    api.get<
      ApiResponse<{
        items: any[];
        total: number;
        page: number;
        pageSize: number;
      }>
    >('/operator/outbox', { params }),

  getOutboxStats: () =>
    api.get<ApiResponse<Record<OutboxStatus, number>>>('/operator/outbox/stats'),

  retryOutboxMessage: (id: string) =>
    api.post<ApiResponse<{ id: string; status: OutboxStatus }>>(
      `/operator/outbox/${id}/retry`,
    ),
};
